<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">公司</label>
          </div>
          <div class="weui-cell__bd">{{form.name}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">地址</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.address" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">电话</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.tel" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">传真</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.fax" placeholder="请填写" />
          </div>
        </div>

        <file-field
          v-model="form.logoUrl"
          value-property="path"
          :max-size="1"
          label="Logo"
          :thumb="true"
          accept="image/*"
        />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import FileField from "@/components/field/FileField.vue";

export default {
  components: {
    FileField
  },
  data() {
    return {
      form: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      me.$ajax({
        url: "/api/account/company/read/current"
      }).then(function(res) {
        if (res.success) {
          me.form = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    save() {
      var me = this,
        main = me.form;
      if (!main.address) {
        me.$weui.topTips("请填写公司地址", 3000);
      } else {
        me.$loading({
          url: "/api/account/company/save",
          method: "POST",
          jsonData: main
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.back();
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      }
    }
  }
};
</script>